import { useCallback, useEffect, useState } from 'react';

import {
  type ModelMessageTemplateLite,
  useLazySearchForSystemQuery,
} from '@app/api/MessageTemplates';
import { useUserPrint } from '@app/hooks/useUserPrint';

type MessageTemplateOffersArgs = {
  query?: string | null;
  withTemplateOffers?: boolean;
};

const normalize = (string?: string) => (string || '').trim().toLowerCase();

export const useMessageTemplateOffers = ({
  query = '',
  withTemplateOffers = false,
}: MessageTemplateOffersArgs) => {
  const {
    params: { ActiveBranchId },
  } = useUserPrint();
  const [offers, setOffers] = useState<ModelMessageTemplateLite[]>([]);

  const [getSystemTemplates] = useLazySearchForSystemQuery();

  const startSearch = useCallback(async () => {
    if (!withTemplateOffers) return;
    if (!query?.trim()) {
      setOffers([]);
      return;
    }

    const response = await getSystemTemplates({
      ActiveBranchId,
      search: query.trim(),
      count: 100000,
    }).unwrap();

    const normalizedQuery = normalize(query);

    const filtered = (response || []).filter(({ Name }) =>
      normalize(Name ?? '').startsWith(normalizedQuery)
    );

    setOffers(filtered);
  }, [ActiveBranchId, getSystemTemplates, query, withTemplateOffers]);

  useEffect(() => {
    startSearch();
  }, [startSearch]);

  return { offers };
};
